import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { isIcon, isStackedIcon, SOFTLINE_ICONS, StackedIcon } from './icon.tokens';
import { IconTypePipe } from './icon-type.pipe';


@Component({
    selector: 'soft-icon',
    imports: [CommonModule, IconTypePipe],
    templateUrl: './icon.component.html',
    styleUrl: './icon.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent {
  registeredIcons = inject(SOFTLINE_ICONS, {optional: true});

  readonly name = input<string | undefined>('');

  readonly registeredIcon = computed(() => {
    if(!this.registeredIcons || !this.name())
      return undefined;
    return this.registeredIcons.find(i => i.name === this.name());
  })

  readonly stackedIcon = computed<StackedIcon | undefined>(() => {
    const registered = this.registeredIcon();
    if(isStackedIcon(registered))
      return registered;
    return undefined;
  });

  readonly icon = computed(() => {
    const registered = this.registeredIcon();
    if(isIcon(registered))
      return registered.icon;
    return this.name();
  })
}
